import React from "react";
import { Container } from "react-bootstrap";
import "../styling/Contact.css";

export const Contact = () => {
  const contactMethods = [
    {
      icon: "envelope",
      title: "Email",
      description: "Send me a message directly",
      value: "robinokwanma@gmail.com",
      link: "mailto:robinokwanma@gmail.com",
      action: "Send Email"
    },
    {
      icon: "whatsapp",
      title: "WhatsApp",
      description: "Quick message or call",
      value: "+234 814 819 0856",
      link: "https://wa.me/2348148190856",
      action: "WhatsApp"
    },
    {
      icon: "linkedin",
      title: "LinkedIn",
      description: "Professional networking",
      value: "Connect with me",
      link: "https://linkedin.com/in/robinokwanma",
      action: "Visit LinkedIn"
    },
    {
      icon: "twitter-x",
      title: "X (Twitter)",
      description: "Send a message on X",
      value: "Robinokwanma",
      link: "https://x.com/robinokwanma",
      action: "Visit X (Twitter)"
    }
  ];

  const socials = [
    {
      platform: "Facebook",
      icon: "facebook",
      url: "https://facebook.com/robinokwanma",
      label: "facebook"
    },
    {
      platform: "X (Twitter)",
      icon: "twitter-x",
      url: "https://x.com/robinokwanma",
      label: "twitter"
    },
    {
      platform: "LinkedIn",
      icon: "linkedin",
      url: "https://linkedin.com/in/robinokwanma",
      label: "linkedin"
    },
    {
      platform: "WhatsApp",
      icon: "whatsapp",
      url: "https://wa.me/2348148190856",
      label: "whatsapp"
    },
    {
      platform: "GitHub",
      icon: "github",
      url: "https://github.com/robinokwanma",
      label: "github"
    }
  ];

  return (
    <section className="contact-section">
      <Container className="contact-container">
        {/* Header */}
        <div className="contact-header">
          <span className="section-accent">Get In Touch</span>
          <h2 className="section-title">
            Let's <span className="title-highlight">Connect</span>
          </h2>
          <p className="section-subtitle">
            Ready to discuss your next project or just say hello? I'd love to hear from you.
          </p>
          <div className="title-underline"></div>
        </div>

        {/* Contact Methods Grid */}
        <div className="contact-methods">
          {contactMethods.map((method, idx) => (
            <div key={idx} className="contact-method-card">
              <div className="method-icon">
                <i className={`bi bi-${method.icon}`}></i>
              </div>
              
              <div className="method-content">
                <h3 className="method-title">{method.title}</h3>
                <p className="method-description">{method.description}</p>
              </div>

              <div className="method-value">
                <p className="value-text">{method.value}</p>
              </div>

              <a 
                href={method.link}
                target="_blank"
                rel="noopener noreferrer"
                className="method-button"
              >
                <span className="btn-text">{method.action}</span>
                <span className="btn-arrow">→</span>
              </a>
            </div>
          ))}
        </div>

        {/* CTA Section */}
        <div className="cta-section">
          <div className="cta-content">
            <h3 className="cta-title">Let's Build Something Amazing</h3>
            <p className="cta-text">
              Whether you need a mobile app, web platform, or fintech solution, I'm here to help transform your ideas into reality.
            </p>

            <div className="cta-buttons">
              <a 
                href="mailto:robinokwanma@gmail.com"
                className="cta-btn primary"
              >
                <i className="bi bi-envelope"></i>
                Email Me
              </a>
              <a 
                href="https://wa.me/2348148190856"
                target="_blank"
                rel="noopener noreferrer"
                className="cta-btn secondary"
              >
                <i className="bi bi-chat-dots"></i>
                Message on WhatsApp
              </a>
            </div>
          </div>
        </div>

        {/* Social Links */}
        <div className="contact-socials">
          <h3 className="socials-title">Follow & Connect</h3>
          <p className="socials-subtitle">Stay updated with my latest projects and insights</p>
          
          <div className="social-icons-grid">
            {socials.map((social, idx) => (
              <a
                key={idx}
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                className="social-link"
                title={social.platform}
                aria-label={`Follow on ${social.platform}`}
              >
                <i className={`bi bi-${social.icon}`}></i>
                <span className="social-label">{social.platform}</span>
              </a>
            ))}
          </div>
        </div>

        {/* Quick Info */}
        <div className="contact-info">
          <div className="info-item">
            <div className="info-icon">
              <i className="bi bi-geo-alt-fill"></i>
            </div>
            <div className="info-content">
              <h4 className="info-title">Location</h4>
              <p className="info-text">Port Harcourt, Nigeria</p>
            </div>
          </div>

          <div className="info-divider"></div>

          <div className="info-item">
            <div className="info-icon">
              <i className="bi bi-clock-history"></i>
            </div>
            <div className="info-content">
              <h4 className="info-title">Response Time</h4>
              <p className="info-text">Usually within 24 hours</p>
            </div>
          </div>

          <div className="info-divider"></div>

          <div className="info-item">
            <div className="info-icon">
              <i className="bi bi-check-circle-fill"></i>
            </div>
            <div className="info-content">
              <h4 className="info-title">Availability</h4>
              <p className="info-text">Available for projects</p>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default Contact;